module.exports = __webpack_public_path__ + "d85e3b795287ea391b3511c0cbd0280f.png";